import { create } from 'zustand'

type SnackbarVariant = 'success' | 'error' | 'warning' | 'info'

interface SnackbarState {
  message: string | null
  variant: SnackbarVariant
  show: (message: string, variant?: SnackbarVariant) => void
  hide: () => void
}

export const useSnackbarStore = create<SnackbarState>((set) => ({
  message: null,
  variant: 'info',
  show: (message, variant = 'info') => set({ message, variant }),
  hide: () => set({ message: null }),
}))
